<div class="flex flex-col items-center whitespace-pre-line px-6 pb-6 pt-5">
    <!-- Icon -->
    @if (icon) {
        <div
            class="mb-4 flex h-12 w-12 items-center justify-center rounded-full ring-4"
            [ngClass]="iconBgClass"
        >
            <i class="text-xl" [ngClass]="iconClass"></i>
        </div>
    }

    <!-- Text -->
    @if (text) {
        <p
            class="mb-5 whitespace-pre-line text-center text-sm leading-relaxed text-slate-500"
        >
            {{ text }}
        </p>
    }

    <!-- Input: text -->
    @if (mode === 'input' && inputType === 'text') {
        <div class="mb-5 w-full">
            @if (inputLabel) {
                <label class="mb-1.5 block text-sm font-medium text-slate-700">
                    {{ inputLabel }}
                </label>
            }
            <input
                type="text"
                [(ngModel)]="inputValue"
                [placeholder]="inputPlaceholder"
                class="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm text-slate-800 placeholder-slate-400 outline-none ring-primary-100 transition-all focus:border-primary-500 focus:ring-4"
            />
        </div>
    }

    <!-- Input: textarea -->
    @if (mode === 'input' && inputType === 'textarea') {
        <div class="mb-5 w-full">
            @if (inputLabel) {
                <label class="mb-1.5 block text-sm font-medium text-slate-700">
                    {{ inputLabel }}
                </label>
            }
            <textarea
                [(ngModel)]="inputValue"
                class="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm text-slate-800 placeholder-slate-400 outline-none ring-primary-100 transition-all focus:border-primary-500 focus:ring-4"
                rows="4"
            ></textarea>
        </div>
    }

    <!-- Input: range -->
    @if (mode === 'input' && inputType === 'range') {
        <div class="mb-5 w-full">
            @if (inputLabel) {
                <label class="mb-2 block text-sm font-medium text-slate-700">
                    {{ inputLabel }}
                </label>
            }
            <div class="flex items-center gap-3">
                <input
                    type="range"
                    class="flex-1 accent-primary-600"
                    [(ngModel)]="inputValue"
                    [min]="inputMin"
                    [max]="inputMax"
                    [step]="inputStep"
                />
                <span
                    class="min-w-[2.5rem] text-center text-sm font-semibold text-slate-700"
                >
                    {{ inputValue }}
                </span>
            </div>
        </div>
    }

    <!-- Timer progress bar -->
    @if (timerProgressBar && timer > 0) {
        <div class="mb-5 h-1 w-full overflow-hidden rounded-full bg-slate-100">
            <div
                class="h-full rounded-full transition-all duration-100 ease-linear"
                [ngClass]="timerBarColorClass"
                [style.width.%]="timerProgress"
            ></div>
        </div>
    }

    <!-- Buttons: confirm / alert mode -->
    @if (mode === 'confirm' || mode === 'alert') {
        <div
            class="flex w-full items-center justify-center gap-3 pt-5"
            [ngClass]="{ 'border-t border-slate-100': hasContentAboveButtons }"
        >
            @if (showDenyButton && mode === 'confirm') {
                <button class="btn btn-white" (click)="onDeny()">
                    {{ denyButtonText }}
                </button>
            }
            @if (showCancelButton && mode === 'confirm') {
                <button class="btn btn-white" (click)="onCancel()">
                    {{ cancelButtonText }}
                </button>
            }
            <button class="btn btn-primary" (click)="onConfirm()">
                {{ confirmButtonText }}
            </button>
        </div>
    }

    <!-- Buttons: multi mode -->
    @if (mode === 'multi') {
        <div
            class="flex w-full items-center justify-center gap-3 pt-5"
            [ngClass]="{ 'border-t border-slate-100': hasContentAboveButtons }"
        >
            @for (btn of buttons; track btn) {
                <button
                    class="btn"
                    [ngClass]="{
                        'btn-primary': btn.type === 'primary',
                        'btn-danger': btn.type === 'danger',
                        'btn-warning': btn.type === 'warning',
                        'btn-success': btn.type === 'success',
                        'btn-white': !btn.type || btn.type === 'default',
                    }"
                    (click)="onButtonClick(btn.key)"
                >
                    {{ btn.text }}
                </button>
            }
        </div>
    }

    <!-- Buttons: input mode -->
    @if (mode === 'input') {
        <div
            class="flex w-full items-center justify-center gap-3 pt-5"
            [ngClass]="{ 'border-t border-slate-100': hasContentAboveButtons }"
        >
            @if (showCancelButton !== false) {
                <button class="btn btn-white" (click)="onCancel()">
                    {{ cancelButtonText }}
                </button>
            }
            <button class="btn btn-primary" (click)="onConfirm()">
                {{ confirmButtonText }}
            </button>
        </div>
    }
</div>
